export const defaultStyle = {
    wrapper: "relative bg-beige",
    container:
        "relative section-wrapper flex flex-col items-center gap-14 pt-8 pb-16 md:pt-16 md:pb-20 lg:gap-16 xlg:pt-24 xlg:pb-32",
    cardsWrapper: "flex gap-4 flex-wrap justify-center",
}
